import {TrmzFileRepository} from "@web-libs/features/files/trmz-file/domain/trmz-file.repository";
import {HttpClient} from "@web-libs/core/http";
import {TrmzFile} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";
import {createTrmzFileDTOConverter} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";
import {TrmzFileDTO} from "@web-libs/features/files/trmz-file/api/trmz-file.types";

type CustomStatus<T> = {
    status: string;
    object: T;
}

export const createTrmzFileRepository = (httpClient:HttpClient, tenantId: string): TrmzFileRepository => {


    const fileConverter = createTrmzFileDTOConverter(
        httpClient.baseUrl,
        tenantId
    )
    const uploadChatroomImage = async (file: File): Promise<TrmzFile> => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await httpClient.postFormData<CustomStatus<TrmzFileDTO>>("/files/upload/logo", formData);
        return fileConverter.parseDTOToFile(response.object);
    }

    return {
        uploadChatroomImage
    }
}
